
    import { defineComponent, PropType } from 'vue'
    import { iOlap } from '../Olap'
    import Dialog from 'primevue/dialog'
    import olapSortingDialogDescriptor from './OlapSortingDialogDescriptor.json'
    import RadioButton from 'primevue/radiobutton'

    export default defineComponent({
        name: 'olap-custom-view-save-dialog',
        components: { Dialog, RadioButton },
        props: { sbiExecutionId: { type: String }, olap: { type: Object as PropType<iOlap> } },
        emits: ['save'],
        data() {
            return {
                olapSortingDialogDescriptor,
                sortingMode: 'no sorting',
                sortingCount: 10
            }
        },
        created() {},
        methods: {
            save() {
                if (this.sortingMode !== 'count' || this.sortingCount < 1) {
                    this.sortingCount = 10
                }
                this.$emit('save', { sortingMode: this.sortingMode, sortingCount: this.sortingCount })
            }
        }
    })
